<template>
    <el-drawer title="待配订单(有货)" @close="closeDialog"  direction="ltr" size="50%"  :visible="ZPYHflag">
      <div style="padding:12px">
        <el-form  :inline="true"  :model="searchFrom1"  class="demo-form-inline"  label-width="80px"  size="mini"  >
          <el-form-item label="捆包号" class="item1">
            <el-input placeholder="" type="textarea" v-model="searchFrom1.cargoBarcode" class="gjh"></el-input>
          </el-form-item>
          <el-button type="primary" @click="searchFn1" style="margin-top:40px">查询</el-button>
          <el-button type="primary" @click="chongzhiFn" style="margin-top:40px">重置</el-button>
        </el-form>
        <div v-for="(item,index) in rowDataList" :key="item.id">
          <div class="box2">
            <p style="color:#409EFF">订单号：{{item.orderNo}}</p>
            <p>结算客户：{{item.payee}}</p>
            <p>共计：<span class="red">{{item.kilometres}}</span>公里（{{item.arriveDepartFlag=='是'?'往返':'单程'}}）</p>
          </div>
          <div class="box1">
            <p>流向：{{item.startDirection}}——{{item.endDirection}}</p>
            <p>合计：
              <span v-if="item.rowDataWeight"><span class="red">{{item.rowDataWeight}}</span>吨</span>
              <span v-if="item.rowDataWeight&&(item.rowDataNumber||item.rowDataVolumn)">/</span>
              <span v-if="item.rowDataNumber"><span class="red">{{item.rowDataNumber}}</span>件</span>
              <span v-if="item.rowDataNumber&&item.rowDataVolumn">/</span>
              <span v-if="item.rowDataVolumn"><span class="red">{{item.rowDataVolumn}}</span>方</span>
            </p>
          </div>
           <el-table height="200px" size="mini" ref="tabref" :data="item.goodList" style="width:100%" border center
            @row-click="handleRowClick($event,index)" @select="(selection, row)=> selectRow({selection:selection,row:row,index:index})" @select-all="quanxuan($event,index)">
            <el-table-column type="selection" width="55"  ></el-table-column>
            <el-table-column type="index"  label="序号" width="60"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量(吨)"
              min-width="100"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="number" label="数量(件)"
              min-width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="volumn" label="体积(方)"
              min-width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="model" label="材质"
              min-width="100"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格"
              min-width="100"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号"
              min-width="150"></el-table-column>
            <el-table-column property="productTypeName"  width="100" label="货物类型">
              <template >
                <div>
                  {{item.productTypeName}}
                </div>
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="cargoLocation" label="货位"
              min-width="100"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号"
              min-width="100"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="agreementNumber" label="合约号"
              min-width="100"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="productName" label="品名"
              min-width="100"></el-table-column>
          </el-table>
        </div>
      </div>
      <el-drawer title="创建运单" size="98%" @close="closeDialog"   class="rightDrawer"
       :modal="false"  :visible="ZPYHflag">
        <div  style="padding:12px">
          <div style="text-align: right;">合计：
              <span v-if="goodform.allWeightT"><span class="red">{{goodform.allWeightT}}</span>吨</span>
              <span v-if="goodform.allWeightT&&(goodform.allNumber||goodform.allVolumn)">/</span>
              <span v-if="goodform.allNumber"><span class="red">{{goodform.allNumber}}</span>件</span>
              <span v-if="goodform.allNumber&&goodform.allVolumn">/</span>
              <span v-if="goodform.allVolumn"><span class="red">{{goodform.allVolumn}}</span>方</span>
          </div>
          <div style="margin-bottom:20px" v-for="(item,index) in xuanList" :key="item.orderNo">
            <div class="box2">
              <p style="color:#409EFF">订单号：{{item.orderNo}}</p>
              <el-button type="primary" @click="qingkongFn(index)" >清空</el-button>
            </div>
            <div class="box1">
              <p>流向：{{item.startDirection}}——{{item.endDirection}}</p>
              <p>结算客户：{{item.payee}}</p>
            </div>
            <el-table height="200px" size="mini" ref="tabref" :data="item.detailsData" style="width:100%" border center>
              <el-table-column type="index"  label="序号" width="60"></el-table-column>
              <el-table-column label="操作"  width="100">
                <template slot-scope="scope">
                  <div>
                    <el-button type="text" size="mini" @click="delGoodFn(scope.$index,index)">删除</el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量(吨)"
                min-width="100"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="number" label="数量(件)"
                min-width="120"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="volumn" label="体积(方)"
                min-width="120"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="model" label="材质"
                min-width="100"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格"
                min-width="100"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号"
                min-width="150"></el-table-column>
              <el-table-column property="productTypeName"  width="100" label="货物类型">
                <template >
                  <div>
                    {{item.productTypeName}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="cargoLocation" label="货位"
                min-width="100"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号"
                min-width="100"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="agreementNumber" label="合约号"
                min-width="100"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="productName" label="品名"
                min-width="100"></el-table-column>
            </el-table>
          </div>
          <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="90px" size="mini">
            <!-- 车辆信息组件 -->
            <cheliangxinxi :goodform="goodform" :isPaidui="true"></cheliangxinxi>
            <!-- 运费信息 -->
            <zhichu2 :goodform="goodform"></zhichu2>
          </el-form>
        </div>
        <div class="footerBox">
          <el-button  @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="saveFn(1)">提交</el-button>
          <el-button type="primary" @click="saveFn(2)">提交并继续</el-button>
          <el-button type="primary" @click="saveFn(3)">提交并打印</el-button>
        </div>
      </el-drawer>
  </el-drawer>

</template>

<script>
import cheliangxinxi from '@/views/newTMS/publicFiles/wayAndOrder/cheliangxinxi.vue'
import zhichu2 from '@/views/newTMS/publicFiles/wayAndOrder/zhichu2.vue'
import { findAssignmentGoods, cargoStowage } from '@/api/newTMS'
export default {
  name: 'zhipaiyouhuo',
  components: {
    cheliangxinxi, zhichu2
  },
  props: {
    ZPYHflag: {
      type: Boolean,
      default: false
    },
    rowDataList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      searchFrom1: {},
      goodform: { allWeight: 0 },
      xuanList: [],
      rules: {
        // publishPricingMethod: [
        //   { required: true, message: '请选择计价方式', trigger: 'blur' }
        // ],
        // pricingMethod: [
        //   { required: true, message: '请选择计价方式', trigger: 'blur' }
        // ],
        payer: [
          { required: true, message: '请输入车队长名称', trigger: 'blur' }
        ],
        payerTaxId: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        causeCancellation: [
          { required: true, message: '请输入作废原因', trigger: 'blur' }
        ],
        expenditurePattern: [
          { required: true, message: '请选择支出方式', trigger: 'blur' }
        ],
        freightPricingType: [
          { required: true, message: '请选择运费计价', trigger: 'blur' }
        ],
        freightUnitPrice: [
          { required: true, message: '请输入运费单价', trigger: 'blur' }
        ],
        allFreightAmount: [
          { required: true, message: '请输入运费金额', trigger: 'blur' }
        ],
        serviceRate: [
          { required: true, message: '请输入服务费率', trigger: 'blur' }
        ],
        serviceCharge: [
          { required: true, message: '请输入服务费', trigger: 'blur' }
        ],
        freightTaxRate: [
          { required: true, message: '请输入运费税率', trigger: 'blur' }
        ]
      },
      allXuanGood: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.$set(this.goodform, 'measuringUnit', this.rowDataList[0].measuringUnit)
    this.$set(this.goodform, 'orderBusinessId', this.rowDataList[0].orderBusinessId)

    // 计算自由车加个需要的值
    this.$set(this.goodform, 'productTypeName', this.rowDataList[0].productTypeName)
    this.$set(this.goodform, 'startDirection', this.rowDataList[0].startDirection)
    this.$set(this.goodform, 'endDirection', this.rowDataList[0].endDirection)
    this.$set(this.goodform, 'payee', this.rowDataList[0].payee)
    this.$set(this.goodform, 'needLength', this.rowDataList[0].needLength)
    this.$set(this.goodform, 'arriveDepartFlag', this.rowDataList[0].arriveDepartFlag)

    // 支出信息回显
    this.$set(this.goodform, 'expenditurePattern', this.rowDataList[0].expenditurePattern)
    this.$set(this.goodform, 'expenditurePatternName', this.rowDataList[0].expenditurePatternName)
    this.$set(this.goodform, 'freightPricingType', this.rowDataList[0].freightPricingType)
    this.$set(this.goodform, 'freightPricingTypeName', this.rowDataList[0].freightPricingTypeName)
    this.$set(this.goodform, 'freightUnitPrice', this.rowDataList[0].freightUnitPrice ? this.rowDataList[0].freightUnitPrice : '')
    this.$set(this.goodform, 'allFreightAmount', this.rowDataList[0].freightAmount ? this.rowDataList[0].freightAmount : '')
    // 赋值承运方式
    this.$set(this.goodform, 'transportMode', this.rowDataList[0].transportMode)

    this.searchFn1()
  },
  methods: {
    // 保存
    saveFn (n) {
      if (this.goodform.allFreightAmount == '0' || this.goodform.allFreightAmount == '0.00') {
        this.$alert('运费金额不能为0', '系统提示')
        return
      }
      const max = Math.max(...this.rowDataList.map(item => item.freightAmount))
      if (max && this.goodform.allFreightAmount > max) {
        this.$alert('运费金额不能大于订单原有金额!', '系统提示')
        return
      }
      if (this.xuanList.length == 0) {
        this.$alert('货物不能为空', '系统提示')
        return
      }
      this.xuanList.some(item => {
        if (item.detailsData.length == 0) {
          this.$alert('货物不能为空', '系统提示')
          return false
        }
      })
      if (this.goodform.WHJKflag) {
        if (!this.goodform.idNumber) {
          this.$alert('请选择司机', '系统提示')
          return false
        }
        if (!this.goodform.plateNumber) {
          this.$alert('请选择车辆', '系统提示')
          return false
        }
        if (this.rowDataList.length > 1) {
          this.$alert('合单不能推送网货！', '系统提示')
          return false
        }
      } else {
        if (this.goodform.transportMode == 1) {
          if (!this.goodform.driverId) {
            this.$alert('请选择司机', '系统提示')
            return false
          }
          if (!this.goodform.plateNumber) {
            this.$alert('请选择车辆', '系统提示')
            return false
          }
        }
      }
      this.$refs.goodform.validate((valid) => {
        if (valid) {
          let arr = []
          this.xuanList.forEach((item, index) => {
            let goodArr = []
            item.detailsData.forEach(item1 => {
              goodArr.push(item1.orderGoodsRelId)
            })
            arr.push({
              orderBusinessId: item.orderBusinessId,
              orderGoodsRelId: goodArr
            })
          })
          this.goodform.stowageOrderList = arr
          if (this.goodform.collectionType == 2) { // 司机
            this.$set(this.goodform, 'payer', this.goodform.driverName)
            this.$set(this.goodform, 'payerTaxId', this.goodform.idNumber)
          }
          // 后台是用payee接收的 再重新赋值一下
          this.$set(this.goodform, 'payee', this.goodform.payer)
          this.$set(this.goodform, 'payeeTaxId', this.goodform.payerTaxId)
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          cargoStowage(this.goodform).then(res => {
            loading.close()
            this.$parent.searchFn()
            if (n == 1) {
              this.$emit('update:ZPYHflag', false)
            } else if (n == 3) {
              this.$emit('update:ZPWHflag', false)
              this.$router.push({ path: '/tmsWayDayin', query: { ids: res } })
            } else {
              this.searchFn1()
              this.xuanList = []
              this.getAllXuanGoodFn()
              this.$set(this.goodform, 'plateNumber', '')
              this.$set(this.goodform, 'licensePlateColor', '')
              this.$set(this.goodform, 'licensePlateColorName', '')
              this.$set(this.goodform, 'vehicleType', '')
              this.$set(this.goodform, 'vehicleTypeName', '')
              this.$set(this.goodform, 'energyType', '')
              this.$set(this.goodform, 'energyTypeName', '')
              this.$set(this.goodform, 'driverId', '')
              this.$set(this.goodform, 'driverName', '')
              this.$set(this.goodform, 'driverPhone', '')
              this.$set(this.goodform, 'idNumber', '')
            }
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 捆包号查询
    searchFn1 () {
      if (this.searchFrom1.cargoBarcode) {
        this.searchFrom1.cargoBarcodes = this.searchFrom1.cargoBarcode.replace(/\n/g, ',')
      } else {
        this.searchFrom1.cargoBarcodes = ''
      }
      this.rowDataList.forEach(item => {
        findAssignmentGoods({ orderId: item.orderId, cargoBarcodes: this.searchFrom1.cargoBarcodes }).then(res => {
          let rowDataWeight = 0
          let rowDataNumber = 0
          let rowDataVolumn = 0
          res.forEach(item => {
            if (item.weight) {
              rowDataWeight = (rowDataWeight * 1000 + item.weight * 1000) / 1000
            }
            if (item.number) {
              rowDataNumber = (rowDataNumber * 1000 + item.number * 1000) / 1000
            }
            if (item.volumn) {
              rowDataVolumn = (rowDataVolumn * 1000 + item.volumn * 1000) / 1000
            }
          })
          item.rowDataWeight = rowDataWeight
          item.rowDataNumber = rowDataNumber
          item.rowDataVolumn = rowDataVolumn
          item.goodList = res
          this.$forceUpdate()
        })
      })
    },
    // 全选
    quanxuan (e, index) {
      if (e.length == 0) {
        this.xuanList.some((item, j) => {
          if (item.orderNo == this.rowDataList[index].orderNo) {
            item.detailsData = []
          }
        })
      } else {
        let flag = false
        this.xuanList.some((item, j) => {
          if (item.orderNo == this.rowDataList[index].orderNo) {
            item.detailsData = []
            this.rowDataList[index].goodList.forEach((item1, i) => {
              item1.xuanIndex = j
              item1.orderIndex = index
              item.detailsData.push(item1)
            })
            flag = false
            return true
          } else {
            flag = true
          }
        })
        if (flag || this.xuanList.length == 0) {
          let arr = []
          this.rowDataList[index].goodList.forEach((item, i) => {
            item.xuanIndex = this.xuanList.length
            item.orderIndex = index
            arr.push(item)
          })
          this.xuanList.push({
            orderNo: this.rowDataList[index].orderNo,
            startDirection: this.rowDataList[index].startDirection,
            endDirection: this.rowDataList[index].endDirection,
            payee: this.rowDataList[index].payee,
            productTypeName: this.rowDataList[index].productTypeName,
            orderBusinessId: this.rowDataList[index].orderBusinessId,
            detailsData: arr
          })
        }
      }
      this.getAllXuanGoodFn()
    },
    // 点击复选框
    selectRow (e) {
      this.luojiFn(e.row, e.index)
      this.getAllXuanGoodFn()
    },
    // 选择货物
    handleRowClick (row, index) {
      this.$refs.tabref[index].toggleRowSelection(row)
      this.luojiFn(row, index)
      this.getAllXuanGoodFn()
    },
    luojiFn (row, index) {
      this.getAllXuanGoodFn()
      let jons = {}
      let flag = this.allXuanGood.some(item => {
        if (row.goodsId == item.goodsId) {
          jons = item
          return true
        } else {
          return false
        }
      })
      if (flag) {
        let goodIndex = this.xuanList[jons.xuanIndex].detailsData.findIndex(item => { return item.goodsId == row.goodsId })
        this.xuanList[jons.xuanIndex].detailsData.splice(goodIndex, 1)
      } else {
        if (this.xuanList.length == 0) {
          row.xuanIndex = 0// 选中订单index
          row.orderIndex = index // 左侧订单index
          this.xuanList.push({
            orderNo: this.rowDataList[index].orderNo,
            startDirection: this.rowDataList[index].startDirection,
            endDirection: this.rowDataList[index].endDirection,
            payee: this.rowDataList[index].payee,
            productTypeName: this.rowDataList[index].productTypeName,
            orderBusinessId: this.rowDataList[index].orderBusinessId,
            detailsData: [row]
          })
        } else {
          let flag = false
          this.xuanList.some((item, j) => {
            if (item.orderNo == this.rowDataList[index].orderNo) {
              row.xuanIndex = j
              row.orderIndex = index
              item.detailsData.push(row)
              flag = false
              return true
            } else {
              flag = true
            }
          })
          if (flag) {
            row.xuanIndex = this.xuanList.length
            row.orderIndex = index
            this.xuanList.push({
              orderNo: this.rowDataList[index].orderNo,
              startDirection: this.rowDataList[index].startDirection,
              endDirection: this.rowDataList[index].endDirection,
              payee: this.rowDataList[index].payee,
              productTypeName: this.rowDataList[index].productTypeName,
              orderBusinessId: this.rowDataList[index].orderBusinessId,
              detailsData: [row]
            })
          }
        }
      }
    },
    getAllXuanGoodFn () {
      let arr = []
      if (this.xuanList.length != 0) {
        this.xuanList.forEach(item => {
          arr = arr.concat(item.detailsData)
        })
      }
      console.log(this.allXuanGood)
      this.allXuanGood = arr
      this.goodform.allWeightT = 0
      this.goodform.allNumber = 0
      this.goodform.allVolumn = 0
      this.allXuanGood.forEach(item => {
        if (item.weight) {
          this.goodform.allWeightT = (this.goodform.allWeightT * 1000 + item.weight * 1000) / 1000
        }
        if (item.number) {
          this.goodform.allNumber = (this.goodform.allNumber * 1000 + item.number * 1000) / 1000
        }
        if (item.volumn) {
          this.goodform.allVolumn = (this.goodform.allVolumn * 1000 + item.volumn * 1000) / 1000
        }
      })

      if (this.goodform.measuringUnit == '吨') {
        this.$set(this.goodform, 'allWeight', this.goodform.allWeightT)
      } else if (this.goodform.measuringUnit == '件') {
        this.$set(this.goodform, 'allWeight', this.goodform.allNumber)
      } else if (this.goodform.measuringUnit == '方') {
        this.$set(this.goodform, 'allWeight', this.goodform.allVolumn)
      }
    },
    // 删除货物
    delGoodFn (goodIndex, xuanIndex) {
      let row = this.xuanList[xuanIndex].detailsData[goodIndex]
      this.$refs.tabref[row.orderIndex].toggleRowSelection(row, false)
      this.xuanList[xuanIndex].detailsData.splice(goodIndex, 1)
      this.getAllXuanGoodFn()
    },
    // 清空
    qingkongFn (index) {
      this.xuanList.splice(index, 1)
      this.getAllXuanGoodFn()
    },
    // 重置
    chongzhiFn () {
      this.$set(this.searchFrom1, 'cargoBarcode', '')
      this.searchFn1()
    },
    closeDialog () {
      this.$emit('update:ZPYHflag', false)
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.box1{
  display: flex;
  flex-wrap:wrap;
  p{
    margin-right: 20px;
    margin-top: 0;
  }
}
.box2{
  display: flex;
  justify-content: space-between;
  align-items: center;
  /deep/.el-button {
    height: 30px;
  }
}
.gjh {
    height: 70px;
    width: 300px;
    /deep/.el-textarea__inner{
      height: 100%;
    }
}
/deep/.el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 6px 0 !important;
}
</style>
